// extracted by mini-css-extract-plugin
module.exports = {"toggle":"StakingToggle_toggle__7X8AC","toggle__item":"StakingToggle_toggle__item__Vv7XN","toggle__item--active":"StakingToggle_toggle__item--active__TqjzG"};